
    <div class="col-12 modal">
        <div class="d-flex flex-column justify-content-center align-items-center">
            <div class="py-10x">
                <img src="../../../assets/images/logos/loading/sand-clock.png" alt="">
            </div>
            <div class="titulo-modal py-20x text-center">
                {{mensaje}}
            </div>       
            <div class="titulo-modal py-10x text-center">
                POR FAVOR, ESPERE...
            </div>
            <div class="subtitulo-modal py-10x text-center">
                LA ESPERA PUEDE TARDAR HASTA {{ getTiempoDeCarga() }} SEGUNDOS
            </div>
        </div>
    </div>